import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import VueCookies from 'vue-cookies'
import Router from 'vue-router'
import store from '@/store'

import MainTemplate from '../layout/Templates/MainTemplate'
import CenteredTemplate from '../layout/Templates/CenteredTemplate'
import MainNavbar from '../layout/MainNavbar.vue'
import MainFooter from '../layout/MainFooter.vue'

const Home = () => import('@/pages/Home/Home')
const NewLandingPage = () => import('@/pages/Home/Routes/LandingPage/NewLandingPage')

const Profile = () => import('@/pages/Profile/Profile')
const MyProfile = () => import('@/pages/Profile/Routes/MyProfile')
const ChangeAvatar = () => import('@/pages/Profile/Routes/ChangeAvatar/ChangeAvatar')

const ShareGifPage = () => import('@/pages/Public/ShareGifPage')
const WechatQr = () => import('@/pages/Public/WechatQr')
const MakeRosterQuest = () => import('@/pages/Public/Quests/MakeRosterQuest')
const MatchPublic = () => import('@/pages/Public/Match/Match')
const MatchPublicGoals = () => import('@/pages/Public/Match/Routes/MatchPublicGoals')
const MatchPublicHighlights = () => import('@/pages/Public/Match/Routes/MatchPublicHighlights')
const StoreToken = () => import('@/pages/Auth/Routes/StoreToken/StoreToken')
const Invite = () => import('@/pages/Auth/Routes/Invite/Invite')
const Unsubscribe = () => import('@/pages/Auth/Routes/Unsubscribe/Unsubscribe')
const Login = () => import('@/pages/Auth/Routes/Login/Login')
const Logout = () => import('@/pages/Auth/Routes/Logout/Logout')
const Register = () => import('@/pages/Auth/Routes/Register/Register')
const ForgottenPassword = () => import('@/pages/Auth/Routes/ForgottenPassword/ForgottenPassword')
const ResetPassword = () => import('@/pages/Auth/Routes/ResetPassword/ResetPassword')
const EmailVerificationConfirmation = () => import('@/pages/Auth/Routes/EmailVerification/EmailVerificationConfirmation')
const Bet21Registration = () => import('@/pages/Auth/Routes/Bet21Registration/Register')
const SignupEplLanding = () => import('@/pages/Auth/Routes/SignupEplLanding/SignupEplLanding')

const RoundMatches = () => import('@/pages/RoundDetail/Routes/RoundMatches')
const MyTeamGoalsStats = () => import('@/pages/RoundDetail/Routes/MyTeam/MyTeamGoalsStats')
const MyTeamCurrentStandings = () => import('@/pages/RoundDetail/Routes/MyTeam/MyTeamCurrentStandings')
const RoundDetailHighlights = () => import('@/pages/RoundDetail/Routes/MyTeam/RoundDetailHighlights')
const RoundPoolStandings = () => import('@/pages/RoundDetail/Routes/MyTeam/RoundPoolStandings')

const RoundDetail = () => import('@/pages/RoundDetail/RoundDetail')
const MatchStats = () => import('@/pages/Match/MatchStats')
const MatchGoalsStats = () => import('@/pages/Match/Routes/MatchGoalsStats')
const MatchRoundCurrentStandings = () => import('@/pages/Match/Routes/MatchRoundCurrentStandings')
const History = () => import('@/pages/History/History')
const HistoryRounds = () => import('@/pages/History/Pages/HistoryRounds')
const HistoryRoundDetail = () => import('@/pages/History/Pages/HistoryRoundDetail')
const HistoryRoundDetailPastMatches = () => import('@/pages/History/Pages/HistoryRoundDetail/PastMatches')
const CurrentStandings = () => import('@/pages/CurrentStandings/CurrentStandings')

const ClanPage = () => import('@/pages/Clan/ClanPage')
const JoinClanPage = () => import('@/pages/Clan/JoinClanPage')
const ClanFriendPicks = () => import('@/pages/Clan/Routes/ClanPicks/ClanFriendPicks')

const Prizes = () => import('@/pages/Prizes/Prizes')
const StaticPage = () => import('@/pages/Pages/StaticPage')

const PageNotFound = () => import('@/pages/Pages/PageNotFound')

Vue.use(Router)
const defaultRouteOptions = {
  meta: {
    title: ({ name }) => name,
  },
}

const isAuthenticated = store.getters['auth/token'] !== null

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/token']) {
    if (store.getters['auth/user'] === null) {
      store.dispatch('auth/fetchUser')
    }
    next()
    return
  }
  if (to.name !== 'logout') {
    VueCookies.set('redirect', window.location.href, '1min')
  }
  next('/login')
}

const ifGuest = (to, from, next) => {
  if (!store.getters['auth/token']) {
    next()
    return
  }
  next('/')
}

const index = new Router({
  mode: 'history',
  routes: [
    {
      ...defaultRouteOptions,
      path: '/2019/a',
      name: 'NewLandingA',
      component: Home,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/2019/b',
      name: 'NewLandingB',
      component: NewLandingPage,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/2019',
      name: 'NewLanding',
      component: NewLandingPage,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/share/:payload*',
      name: 'ShareGif',
      component: ShareGifPage,
    },
    {
      ...defaultRouteOptions,
      path: '/wechat',
      name: 'Wechat',
      component: WechatQr,
    },
    {
      ...defaultRouteOptions,
      path: '/make-a-roster',
      name: 'MakeARoster',
      component: MakeRosterQuest,
    },
    {
      ...defaultRouteOptions,
      path: '/storeToken/:token*',
      name: 'StoreToken',
      title: 'StoreToken',
      props: true,
      component: StoreToken,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/invite/:hash*',
      name: 'Invite',
      title: 'Invite',
      props: true,
      component: Invite,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/login',
      name: 'login',
      components: {
        template: CenteredTemplate,
        default: Login,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'login',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/forgotten-password',
      name: 'forgotten-password',
      components: {
        template: CenteredTemplate,
        default: ForgottenPassword,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'forgotten-password',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/reset-password/:token',
      name: 'recover-my-password',
      components: {
        template: CenteredTemplate,
        default: ResetPassword,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'recover-my-password',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/register',
      name: 'register',
      components: {
        template: CenteredTemplate,
        default: Register,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'register',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
      beforeEnter: ifGuest,
    },

    {
      ...defaultRouteOptions,
      path: '/pick-now-epl',
      name: 'signup-epl-landing',
      component: SignupEplLanding,
      beforeEnter: ifGuest,
    },
    {
      ...defaultRouteOptions,
      path: '/21bet',
      name: 'bet21registration',
      components: {
        template: CenteredTemplate,
        default: Bet21Registration,
        header: MainNavbar,
      },
      props: {
        header: {
          hasSmallLogo: true,
          smallLogoPath: '21Bet_logo.png',
          hasBigLogo: false,
          hasMenu: false,
          isGameSwitcherHidden: true,
        },
      },
    },
    {
      ...defaultRouteOptions,
      path: '/logout',
      name: 'logout',
      component: Logout,
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/round-detail/:roundId',
      beforeEnter: ifAuthenticated,
      component: RoundDetail,
      props: true,
      children: [
        {
          path: '',
          name: 'round-detail',
          component: MyTeamGoalsStats,
        },
        {
          path: 'current-standings',
          name: 'round-current-standings',
          component: MyTeamCurrentStandings,
        },
        {
          path: 'highlights',
          name: 'round-highlights',
          component: RoundDetailHighlights,
        },
        {
          path: 'matches',
          name: 'round-detail-matches',
          component: RoundMatches,
        },
        {
          path: 'pool-standings',
          name: 'round-pool-standings',
          component: RoundPoolStandings,
        },
      ],
    },
    {
      ...defaultRouteOptions,
      path: '/match/:league/:match',
      component: isAuthenticated ? MatchStats : MatchPublic,
      props: true,
      children: [
        {
          path: '',
          component: isAuthenticated ? MatchGoalsStats : MatchPublicGoals,
          name: 'match',
        },
        {
          path: 'standings',
          component: MatchRoundCurrentStandings,
          name: 'match-current-standings',
          beforeEnter: ifAuthenticated,
        },
        {
          path: 'highlights',
          component: MatchPublicHighlights,
          name: 'match-public-highlights',
          beforeEnter: ifGuest,
        },
      ],
    },
    {
      ...defaultRouteOptions,
      path: '/history',
      props: true,
      component: History,
      beforeEnter: ifAuthenticated,
      children: [
        {
          path: '',
          component: HistoryRounds,
          name: 'history',
        },
        {
          path: 'round/:roundId',
          props: true,
          component: HistoryRoundDetail,
          children: [
            {
              path: '',
              component: HistoryRoundDetailPastMatches,
              name: 'round-history',
            },
            {
              path: 'standings',
              component: MatchRoundCurrentStandings,
              name: 'round-history-standings',
            },
          ],
        },
      ],
    },
    {
      ...defaultRouteOptions,
      path: '/profile',
      component: Profile,
      beforeEnter: ifAuthenticated,
      props: (route) => ({ title: route.name }),
      children: [
        {
          path: '/',
          component: MyProfile,
          name: 'my-profile',
        },
        {
          path: 'avatar',
          component: ChangeAvatar,
          name: 'change-avatar',
        },
      ],
    },
    {
      ...defaultRouteOptions,
      path: '/standings',
      component: CurrentStandings,
      beforeEnter: ifAuthenticated,
      name: 'current-round-standings',
    },
    {
      ...defaultRouteOptions,
      path: '/prizes',
      name: 'prizes',
      components: {
        template: MainTemplate,
        default: Prizes,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'PRIZES',
          hasSmallLogo: true,
          hasMenu: true,
        },
      },
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/my-friends',
      name: 'my-friends-page',
      components: {
        template: MainTemplate,
        default: ClanPage,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'MY-FRIENDS',
          hasSmallLogo: true,
          hasMenu: true,
        },
      },
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/my-friends/:userId/picks',
      name: 'my-friends-picks-page',
      components: {
        template: MainTemplate,
        default: ClanFriendPicks,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'MY-FRIENDS-PICKS',
          hasSmallLogo: true,
          hasMenu: true,
        },
      },
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/join/:password',
      name: 'join-clan',
      component: JoinClanPage,
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/rules',
      name: 'rules',
      component: StaticPage,
      props: {
        index: 'rules',
      },
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/terms-and-conditions',
      name: 'terms-and-conditions',
      component: StaticPage,
      props: {
        index: 'terms-and-conditions',
      },
      beforeEnter: ifAuthenticated,
    },
    {
      ...defaultRouteOptions,
      path: '/unsubscribe/:hash',
      name: 'unsubscribe',
      components: {
        template: MainTemplate,
        default: Unsubscribe,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'UNSUBSCRIBE',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
    },
    {
      ...defaultRouteOptions,
      path: '/email-verification/:hash',
      name: 'email-verification',
      components: {
        template: CenteredTemplate,
        default: EmailVerificationConfirmation,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          title: 'EMAIL-VERIFICATION',
          hasBigLogo: true,
          hasMenu: false,
        },
      },
    },
    {
      ...defaultRouteOptions,
      path: '/',
      component: Home,
      props: {
        template: {
          isDark: true,
        },
        footer: {
          variant: 'dark',
        },
      },
      children: [
        {
          path: '',
          name: 'home',
        },
        {
          path: 'closed-rounds',
          name: 'closed-rounds',
        },
      ],
    },
    {
      ...defaultRouteOptions,
      path: '*',
      name: 'page-not-found',
      components: {
        template: CenteredTemplate,
        default: PageNotFound,
        header: MainNavbar,
        footer: MainFooter,
      },
      props: {
        header: {
          isBackArrowEnabled: true,
          hasBigLogo: false,
          hasMenu: false,
        },
      },
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      VueScrollTo.scrollTo(to.hash)
    } else {
      if (savedPosition) {
        return savedPosition
      } else {
        return { x: 0, y: 0 }
      }
    }
  },
  base: '/'//process.env.NODE_ENV !== 'development' ? '/app/' : '/',
})

index.afterEach(to => {
  Vue.nextTick(() => {
    const { meta: { title } } = to
    if (title) {
      document.title = title
    }
  })
})

export default index
